import React from 'react'
import { Modal } from 'react-bootstrap';




export default function ModalDialog(props) {
    return (

<Modal show={props.show} onHide={() => props.onHide()}
    size="lg" dialogClassName="addFormModal" >
    <Modal.Header closeButton>
        {props.title && <Modal.Title>{props.title}</Modal.Title>}        
    </Modal.Header>
        {props.body && <Modal.Body>{props.body}</Modal.Body>}       
    <Modal.Footer>
    {props.footer && <Modal.Footer>{props.footer}</Modal.Footer>}    
    </Modal.Footer>
</Modal>)
};